import api from "./api";
import {globalUpdate} from "./AppRouter";
import BUser from "../models/BUser";
import auth from "./auth";


const notLoginedUser = {
    username: 'anonymous',
    name: 'Гость',
    id: -1,
    roles: []
}


class Auth {

    reset() {
        this._user = null;
        this._menu = null;
        this._userLoading = false;
        this._menuLoading = false;
    }

    _user: BUser|any = null;
    _menu: any = null;
    _rights: any = {};

    can(what: string, ...args: any) {
        if (what === 'translator' && auth._user && auth._user.username === 'nc-14') return true;
        for (let right in this._rights) {
            right = right.replace(".", "\\.");
            right = right.replace("?", ".?");
            right = right.replace("*", ".*");
            let expr = new RegExp("^" + right + "$");
            let exprResult = expr.exec(what);
            if (exprResult !== null) return true;
        }
        return this._rights[what];
    }
    _userLoading = false
    user() {
        if (this._user === null) {
            if (!this._userLoading) {
                this._userLoading = true;
                api.get<BUser>("auth/user").ok((message) => {
                    if (!message.data) {
                        this._user = notLoginedUser
                    } else {
                        this._user = message.data
                    }
                    this._rights = {}
                    for (let role of this._user.roles) {
                        const rights = role.rights.split(" ");
                        for (let right of rights) {
                            this._rights[right] = true;
                        }
                    }
                    globalUpdate()
                })
            }
        }
        return this._user;
    }

    _menuLoading = false;
    menu() {
        if (this._menu === null) {
            if (!this._menuLoading) {
                this._menuLoading = true;
                api.get('auth/menu').ok((message) => {
                    this._menu = message.data
                    globalUpdate()
                }).error((error) => {
                    this._menu = []
                    globalUpdate()
                })
            }
        }
        return this._menu??[];
    }

    isMenuHidden = false
    hideMenu() {
        this.isMenuHidden = true
        globalUpdate()
    }
}

export default new Auth()
